import styled from 'styled-components'
import { grid, GridProps, padding, PaddingProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !['gridTemplateColumns', 'secondary'].includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  GridProps & GapProps
>`
  display: grid;
  width: 100%;

  ${grid}
  ${gap}
`

export const Card = styled.div<PaddingProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  gap: ${themeGet('space.7')}px;

  ${padding}
`
